import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const portfolioSubMenuRegistry = {
    personalize_portfolioSub: {
        label: "Portfolio Sub",
        link: PAGE_URL.PORTFOLIO_SUB_PAGE,
        key: PAGE_URL.PORTFOLIO_SUB_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default portfolioSubMenuRegistry;
